import React from 'react';
import Button from '@material-ui/core/Button';
import { ValidatorForm } from 'react-material-ui-form-validator';
import apiClient, { getAccessToken } from '../../apiClient';
import './Role.scss';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { CSVLink } from "react-csv";
import { withRouter } from 'react-router-dom';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox } from '@material-ui/core';
import withFlashNotification from '../Notification/withFlashNotification';
import { notifyApiError } from '../Notification/notificationHelpers';

 class Role extends React.Component {


    
    state = {
        Results: [],
        columns: [
            { title: 'PermissionName', field: 'PermissionName' },
            { title: 'PermissionAllowed', field: 'PermissionAllowed', editable: true,
            editComponent: (props) => (
              <input
                type="checkbox"
                checked={props.value}
                onChange={(e) => props.onChange(e.target.checked)}
              />
            ),
            render: (rowData) => (
              <input type="checkbox" checked={rowData.PermissionAllowed} disabled />
            )
          }
        ],
        headers: [
          { label: "Permission", key: "PermissionName" },
          { label: "PermissionAllowed", key: "PermissionAllowed" }
        ],
        roleList: [],
        formData: {
            rolePermissionId: 0,
            permission: '',
            permissionAllowed: ''
        },
        rollId:1,
        submitted: false,
        successMessage:null,
        errorMessage:null,
       
    }

    componentDidMount() {
        let accessToken = getAccessToken();
  
        apiClient.get(`/api/get/role`, { headers: {"Authorization" : `Bearer ${accessToken}`} })
          .then(res => {
            const roleList = res.data;
            this.setState({ roleList });
          })
          .catch(error => notifyApiError(
            this.props.showFlashNotification,
            error,
            'Unable to load roles.'
          ));

          this.componentPopulatePermissions(1);
        
      }

      componentPopulatePermissions(value) {
        let accessToken = getAccessToken();
  
        
          const params = {
            roleid:  value ,
            };
    
    
          apiClient.get(`/api/get/permission`, {params: params , headers: {"Authorization" : `Bearer ${accessToken}`} })
          .then(res => {
            const Results = res.data;
            this.setState({ Results });
          })
          .catch(error => notifyApiError(
            this.props.showFlashNotification,
            error,
            'Unable to load role permissions.'
          ));

        
      }

    handleChange = (event) => {
      this.state.rollId = event.target.value;
      this.componentPopulatePermissions(this.state.rollId);
      
    }

    handleSubmit = () => {

        let user = JSON.parse(sessionStorage.getItem('user'));
        let accessToken = user.accessToken;
       
        apiClient.post(`/api/post/role`, { Data :  this.state.Results}, { headers: {"Authorization" : `Bearer ${accessToken}`} })
        .then(res => {
           
          this.setState({ successMessage: 'Successfully saved!' });
  
         
          setTimeout(() => {
            this.setState({ successMessage: null });
          }, 3000);
         
        })
        .catch(error => notifyApiError(
          this.props.showFlashNotification,
          error,
          'Unable to save role permissions.'
        ));

    }

    handleChildClick = () => {
      this.props.onSendValue();
      };

      handleCheckboxChange= (value) => {
        
        var permission = this.state.Results.filter(x=>x.RolePermissionId == value);

        if(permission.length > 0)
        {
          if(permission[0].PermissionAllowed == 1)
          {
            permission[0].PermissionAllowed = 0;
          }
          else
           {
           permission[0].PermissionAllowed = 1;
           }
            
        }

        const Results = this.state.Results;
        this.setState({ Results });
        
        };

    render() {
      sessionStorage.setItem('TranSearch', null);
      sessionStorage.setItem('ItemTabIndex', JSON.stringify(0));
        const { submitted } = this.state;
        return (
        <div className="Role">
          
                  
            <ValidatorForm
                ref="form"
               
            >
                           <h2>Role Form</h2>
                           <br/>
                <FormControl>
      <InputLabel id="dropdown-label">Select Role</InputLabel>
                
                <Select
                        name="roleid"
                        value={this.state.rollId}
                        onChange={this.handleChange}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}

                    >
                      
                        {this.state.roleList.map((item) => (
                        
                        <MenuItem value={item.RoleId}>  {item.Role}</MenuItem>
                        ))}
                       
                    </Select>
                    </FormControl>

                <br />
               
                {this.state.successMessage && (
          <div
            style={{
              backgroundColor: '#28a745',
              color: '#fff',
              padding: '10px',
              marginTop: '10px',
            }}
          >
            {this.state.successMessage}
          </div>
        )}

{this.state.errorMessage && (
        <div style={{ backgroundColor: '#FF7F7F', color: '#fff', padding: '10px', marginTop: '10px' }}>
          {this.state.errorMessage}
        </div>
      )}
            </ValidatorForm>


<div style={{ maxWidth: '100%', paddingTop: '50px' }}>
<div style={{textAlign:'right', paddingBottom: '3px'}}>
<CSVLink data={this.state.Results} headers={this.state.headers}>
Export to Excel
</CSVLink>

</div>

<TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Permission</TableCell>
            <TableCell>Allowed</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {this.state.Results.map(item => (
            <TableRow key={item.RolePermissionId}>
              <TableCell>{item.PermissionName}</TableCell>
              <TableCell>
                <Checkbox
                  checked={item.PermissionAllowed == 1? true:false}
                  onChange={() => this.handleCheckboxChange(item.RolePermissionId)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>

    <br /><br />
    {
this.state.rollId > 1 &&
<Button
onClick={this.handleSubmit}
 color="primary"
 variant="contained"
 type="button"
 disabled={submitted}
>
 {
     (submitted && 'Your form is submitted!')
     || (!submitted && 'Submit')
 }
</Button>

    }
               
                
                {this.state.successMessage && (
          <div
            style={{
              backgroundColor: '#28a745',
              color: '#fff',
              padding: '10px',
              marginTop: '10px',
            }}
          >
            {this.state.successMessage}
          </div>
        )}
              




</div>


          
         </div>
        
        );
    }
}
export default withRouter(withFlashNotification(Role));
